import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'collage student moving page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'collage student moving page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>College</span><span>Student Moving Services</span>',
  description:
    'Make your college move stress-free with our affordable moving services. We handle logistics so you can focus on settling in, providing secure and fast solutions nationwide.',
  image: {
    url: '/images/v2/pages/landing-pages/college-student-moving/hero-image.jpg',
    alt: 'Reliable College Student Moving Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find College Student Moving' }
}

export const ourProcessSectionContent = {
  title: 'How We Make College Student Moving Easy',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/college-student-moving/how-we-make-college-student-moving-easy.png',
    alt: 'How We Make College Student Moving Easy'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description: 'Schedule your moving date online, and we’ll take care of the rest, from pickup to delivery.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/easy-online-booking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Safe and Secure Handling',
      description: 'Your belongings are packed and moved with care to ensure they remain safe throughout the journey.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/safe-and-secure-handling.png',
        alt: 'Safe and Secure Handling'
      }
    },
    {
      id: 3,
      title: 'Flexible Pickup and Delivery',
      description: 'Enjoy customizable moving plans designed to meet the unique needs of college students.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/flexible-pickup-and-delivery.png',
        alt: 'Flexible Pickup and Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable College Student Moving Services',
  description:
    'ShipAndStorage offers reliable, affordable moving solutions for students nationwide. We make the college moving process stress-free, ensuring your belongings are safely and promptly delivered to your destination. Experience a smooth transition to campus with our student-focused services.',
  image: {
    src: '/images/v2/pages/landing-pages/college-student-moving/affordable-college-student-moving-services.jpg',
    alt: 'Affordable College Student Moving Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using ShipAndStorage for College Student Moving',

  cards: [
    {
      id: 1,
      title: 'Affordable Rates',
      description: 'Our student-friendly prices ensure you get quality moving services without overspending.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/affordable-rates.png',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 2,
      title: 'Hassle-Free Process',
      description: 'From packing and storage to delivery, we handle every step, making your move stress-free.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/hassle-free-process.png',
        alt: 'Hassle-Free Process'
      }
    },
    {
      id: 3,
      title: 'Nationwide Coverage',
      description: 'We provide reliable moving services to colleges, dorms, and residences across the U.S.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/nationwide-coverage.png',
        alt: 'Nationwide Coverage'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose ShipAndStorage for College Student Moving?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'First-Year Students',
          description: 'Transitioning to college is easier with our seamless moving services.'
        },
        {
          id: 2,
          title: 'Returning Students',
          description: 'Moving between dorms or apartments? We simplify the process for you.'
        },
        {
          id: 3,
          title: 'Parents Assisting Students',
          description: 'Parents can count on us for reliable, affordable moving services.'
        },
        {
          id: 4,
          title: 'International Students',
          description: 'We offer specialized moving solutions for students relocating to the U.S.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/who-should-choose-shipandstorage-for-college-student-moving.jpg',
        alt: 'Who Should Choose ShipAndStorage for College Student Moving?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage and Moving Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description: 'Secure storage for inventory, equipment, and documents at competitive rates.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Flexible storage options to make your moving process smooth and worry-free.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally and internationally with ease.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Perfect for homeowners in need of temporary storage during a move or renovation.',
      image: {
        src: '/images/v2/pages/landing-pages/college-student-moving/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for College Student Moving?',

  image: {
    url: '/images/v2/pages/landing-pages/college-student-moving/why-choose-shipandstorage-for-college-student-moving.jpg',
    alt: 'Why Choose ShipAndStorage for College Student Moving?'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Moving Solutions',
      description: 'From start to finish, we manage the entire moving process for you.'
    },
    {
      id: 2,
      title: 'Flexible Moving Plans',
      description: 'Choose the moving package that fits your schedule and needs perfectly.'
    },
    {
      id: 3,
      title: 'Transparent Pricing',
      description: 'Our clear and affordable pricing includes no hidden fees.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Delivery',
      description: 'Count on us for timely delivery to your new dorm or apartment.'
    },
    {
      id: 5,
      title: 'Secure Handling of Belongings',
      description: 'We ensure your items are packed and transported with the utmost care.'
    },
    {
      id: 6,
      title: 'Student-Centered Services',
      description: 'We meet the needs of college students with convenience and ease.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable College Student Moving Services Available',
  description:
    'Fast and reliable college student moving services. Affordable, secure solutions for moving your belongings to and from campus.',
  image: {
    src: '/images/v2/pages/landing-pages/college-student-moving/reliable-college-student-moving-services-available.png',
    alt: 'Reliable College Student Moving Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your College Move Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'We collaborate with leading global carriers like FedEx, DHL, and UPS to ensure secure and efficient moving and storage solutions for students.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Since 1971, FedEx has been a global leader in shipping, providing reliable logistics with a fleet of 696 aircraft and 215,000 vehicles.',
        "<Strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL operates in over 220 countries, offering dependable international courier, parcel, and express mail services with over 1.8 billion parcels handled annually.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Founded in 1907, UPS is a trusted name in logistics, delivering 25 million packages daily to over 220 countries with unmatched reliability.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved"
      ]
    }
  ]
}
